const GRADE_ORDER = ["Premium-Priority", "Premium-Confirm", "Peripheral-Watch", "Table Stake-Repair", "Table Stake-Maintain"];

const gradeOrder = grade => {
  const index = GRADE_ORDER.indexOf(grade);
  return index === -1 ? GRADE_ORDER.length : index;
};

export default {
  sortRows(rows) {
    return [...rows].sort((left, right) => {
      const groupDifference = gradeOrder(left.label) - gradeOrder(right.label);
      if (groupDifference) return groupDifference;
      if (left.label !== right.label) return String(left.label || "").localeCompare(String(right.label || ""));
      if (!Number.isFinite(left.capturableWtp)) return Number.isFinite(right.capturableWtp) ? 1 : 0;
      if (!Number.isFinite(right.capturableWtp)) return -1;
      return right.capturableWtp - left.capturableWtp;
    });
  }
};
